define('SageDotCom/Components/AgnosticProductCard/AgnosticProductCardPricing',["jquery",
    "eventManager",
    "SageDotCom/Components/ProductCardAlignment",
    "SageDotCom/DataLayer/Events/product-card-detail",
    "SageDotCom/DataLayer/Events/DynamicProductModal",
    "SageDotCom/Utility/sanitizer",
    'visitorIdCookie'],
    function ($, eventManager, productCardAlignment, ProductCardDetailEvent, modalEvents, sanitizer, visitorIdCookie) {
        function AgnosticProductCardPricing(
            scope,
            productSku,
            promoCodeOverwrite,
            promoTemplateOverride,
            crossSellFlag,
            crossSellPromoOverwrite,
            optionsAsRadio,
            crossSellPricePostText,
            crossSellRadioExtraText,
            crossSellRadioPromoPillFreeText,
            crossSellRadioPromoPillDiscountText,
            crossSellPromoTemplateOverride,
            addonFlag,
            addonSku,
            addonPromoOverwrite,
            addonPromoTemplate,
            variantFlag,
            useContactUs,
            selectBoxFormat,
            modalId,
            freeLabel,
            currencyFormat,
            currencyFormatWithChange,
            employeeLabel,
            dayLabel,
            daysLabel,
            monthLabel,
            monthsLabel,
            isEditing,
            isPreview) {

            //start common variables 
            const $scope = $(scope);
            promoCodeOverwrite = promoCodeOverwrite.trim();
            const productService = new ProductCardDetailEvent();
            //end common variables 
            //start locale detection 
            var locale = undefined;
            var currentUrl = undefined;

            function isValidInternalUrl(url) {
                try {
                    const parsedUrl = new URL(url, window.location.origin);
                    return parsedUrl.origin === window.location.origin;
                } catch (e) {
                    return false;
                }
            }

            function log(message) {
                if (window.enableLogging) {
                    console.log("SAGE DEBUG: ", message);
                }
            }

            if (!(isEditing || isPreview)) {
                const pathName = document.location.pathname;
                const localeArr = pathName.split("/");
                for (let i = 0; i < localeArr.length; i++) {
                    if (localeArr[i] !== "") {
                        locale = localeArr[i];
                        log(`Locale is from pathname (${pathName}): ${locale}`);
                        break;
                    }
                }
            }

            if (locale === undefined) {
                //might not be explicitly editing or preview, but might be snippet view 
                currentUrl = new URL(window.location.href);
                locale = currentUrl.searchParams.get("sc_lang");
                log(`Locale is from sc_lang: ${locale}`);
            }
            //end locale detection 

            //start Detect cross-sell variants behaviour 
            const $addonCheckButton = $(".cross-sell-check", scope);
            const $skuWrapper = $scope.find(".sku-input-wrapper");
            let detectingCrossSell = false;
            const detectCrossSellClick = (newSku, useUpdater = false) => {
                if (!detectingCrossSell) {
                    //prevent doing multiple calls at once 
                    detectingCrossSell = true;

                    const inputSku = (!newSku || typeof newSku !== "string" || newSku.trim() === "")
                        ? $skuWrapper.find("span[sc-part-of='field']").text()
                        : newSku;

                    if (!inputSku || typeof inputSku !== "string" || inputSku.trim() === "" || inputSku.trim() === "SKU: [No text in field]") {
                        alert("You must input a SKU, first");
                        return;
                    }

                    const $checkboxCrossSellArea = $(".dynamic-product-card-updater .checkboxCrossSellArea");
                    const AddSpinner = ($element) => {
                        if ($element.length) {
                            $element.addClass("icon-loader icon-loader-black");
                        }
                    }
                    const RemoveSpinner = ($element) => {
                        if ($element.length) {
                            $element.removeClass("icon-loader icon-loader-black");
                        }
                    }

                    AddSpinner($addonCheckButton);

                    $.ajax({
                        type: "GET",
                        url: `/sitecore/api/product/BaseCrossSellForProduct/${inputSku}/${locale}`,
                        context: this
                    }).done(function (response) {
                        var jsonObj = JSON.parse(response);
                        if (jsonObj === null) {
                            console.error("jsonObj was null - Stopping the treatment");
                            if (useUpdater) {
                                $(".dynamic-product-card-updater .promo-overwrite-container").empty();
                                RemoveSpinner($checkboxCrossSellArea);
                                $(".dynamic-product-card-updater .checkboxCrossSell").prop("checked", false);
                            }
                        }
                        else {
                            var productIndexesContainer = $scope.find(".product-indexes");
                            productIndexesContainer.empty();
                            var promoOverwriteContainer = $scope.find(".promo-overwrite-list");
                            promoOverwriteContainer.empty();
                            const promoBtnContainer = $(".promo-overwrite-btn-container", scope);
                            $(".promo-overwrite-helptext", scope).removeClass("hidden");
                            promoBtnContainer.empty();

                            let newPromosArray = [];
                            if (useUpdater) {
                                const existingCrossSellPromos = window.productCardUpdater_newPromo
                                    ? window.productCardUpdater_newPromo
                                    : "";
                                newPromosArray = existingCrossSellPromos.split("-");
                                AddSpinner($checkboxCrossSellArea);
                            }

                            jsonObj.forEach(function (product, i) {
                                const variantInfoObj = $("<div>").addClass("product-index").html(`${i} is for variant${i < jsonObj.length - 1 ? "s" : ""}: ${getProductNames(jsonObj, i)}`);
                                const promoWrapper = document.createElement("div");

                                if (useUpdater && newPromosArray.length === jsonObj.length) {
                                    promoWrapper.innerHTML = ` 
                                     <div class="promo-overwrite-wrapper"> 
                                         <label>${product.Name}</label> 
                                         <input type="text" class="promo-input" placeholder="Enter promo code" value="${newPromosArray[i]}" > 
                                     </div> 
                                     `;
                                } else {
                                    promoWrapper.innerHTML = ` 
                                     <div class="promo-overwrite-wrapper"> 
                                         <label class="score-editField">${product.BundleSku}</label> 
                                         <input type="text" class="promo-input" placeholder="Enter promo code"> 
                                     </div> 
                                     `;
                                }

                                if (promoOverwriteContainer.length > 0) {
                                    promoOverwriteContainer.append(promoWrapper);
                                }
                                if (productIndexesContainer.length > 0) {
                                    productIndexesContainer.append(variantInfoObj);
                                }
                            });

                            if (useUpdater) {
                                RemoveSpinner($checkboxCrossSellArea);
                            }

                            var hiddenInput = $scope.find(".promo-overwrite-input span[contenteditable='true']");
                            const combineButton = $("<button>").addClass("score-button").text("Combine Inputs");

                            // Add an event listener to the button 
                            combineButton.on("click", function () {
                                const combinedValues = $(".promo-input").map(function () {
                                    const value = $(this).val(); // Get the input value 
                                    return value;
                                }).get();

                                // Combine label-value pairs with "-" separator 
                                const concatedValues = combinedValues.join("");
                                const combinedValue = concatedValues !== "" ? combinedValues.join("-") : "";

                                // Inject the combined value into the hidden input field 
                                hiddenInput.text(combinedValue);
                            });

                            // Append the button and hidden input 
                            if (promoBtnContainer.length > 0) {
                                promoBtnContainer.append(combineButton);
                            }

                            eventManager.trigger("adjust-agnostic-cards");

                            function getProductNames(products, index) {
                                return products.slice(index, products.length).map(product => product.Name).join(", ");
                            }
                        }
                        detectingCrossSell = false;
                        RemoveSpinner($addonCheckButton);
                    });
                }
            }

            if ($(".dynamic-product-card-updater").length) {
                eventManager.subscribe("productCardCrossSellUpdated", (newSku, useUpdater) => detectCrossSellClick(newSku, useUpdater));
            }
            //end Detect cross-sell variants behaviour 

            currencyFormat = currencyFormat.replace("11", "x");
            currencyFormatWithChange = currencyFormatWithChange.replace("11", "x").replace("99", "y");

            const formatPrice = (value) => {
                if (value === freeLabel) {
                    return freeLabel;
                }

                const pennies = (value * 100) % 100;
                if (pennies === 0) {
                    //whole number 
                    return currencyFormat.replace("x", value);
                }
                else {
                    //has change 
                    let larger = ((value * 100) - pennies) / 100;
                    let roundedPennies = Math.round(pennies);
                    if (roundedPennies >= 100) {
                        larger++;
                        roundedPennies = roundedPennies - 100;
                    }
                    if (roundedPennies === 0) {
                        return currencyFormat.replace("x", larger);
                    }
                    else {
                        return currencyFormatWithChange.replace("x", larger).replace("y", roundedPennies);
                    }
                }
            }

            function replacePromoPeriod(promoText, periodType, periodLength) {

                function pluralOrSingular(value, plural, singular) {
                    return value === 1 ? singular : plural;
                }

                const promoPeriodType = periodType.toLowerCase();
                if (promoPeriodType === "month") {
                    promoText = promoText.replace("[promoPeriod]", pluralOrSingular(periodLength, monthsLabel, monthLabel));
                }
                else if (promoPeriodType === "day") {
                    promoText = promoText.replace("[promoPeriod]", pluralOrSingular(periodLength, daysLabel, dayLabel));
                }

                return promoText;
            }

            if (isEditing) {
                //experience editor 
                //start Checkbox behaviour 
                const $crossSellCheckboxWrapper = $scope.find(".cross-sell-checkbox-wrapper");
                const $crossSellCheckbox = $crossSellCheckboxWrapper.find("input[type='checkbox']");
                const $crossSellFieldsArea = $scope.find(".cross-sell-fields");
                const $addonCheckboxWrapper = $scope.find(".addon-checkbox-wrapper");
                const $addonCheckbox = $addonCheckboxWrapper.find("input[type='checkbox']");
                const $addonFieldsArea = $scope.find(".addon-fields");
                const $variantCheckboxWrapper = $scope.find(".variant-checkbox-wrapper");
                const $variantCheckbox = $variantCheckboxWrapper.find("input[type='checkbox']");
                const $variantFieldsArea = $scope.find(".variant-fields");
                const $warning = $(scope).find(".checkbox-warning");

                function checkVisibleFields() {
                    var crossSellChecked = $crossSellCheckbox.is(":checked");
                    var addonChecked = $addonCheckbox.is(":checked");
                    var variantChecked = $variantCheckbox.is(":checked");

                    if (crossSellChecked) {
                        $crossSellFieldsArea.removeClass("hidden");
                    } else {
                        $crossSellFieldsArea.addClass("hidden");
                    }

                    if (addonChecked) {
                        $addonFieldsArea.removeClass("hidden");
                    } else {
                        $addonFieldsArea.addClass("hidden");
                    }

                    if (variantChecked) {
                        $variantFieldsArea.removeClass("hidden");
                    } else {
                        $variantFieldsArea.addClass("hidden");
                    }

                    if ((crossSellChecked && addonChecked) || (addonChecked && variantChecked)) {
                        $warning.removeClass("hidden");
                    } else {
                        $warning.addClass("hidden");
                    }
                }

                $crossSellCheckbox.on("click", checkVisibleFields);
                $addonCheckbox.on("click", checkVisibleFields);
                $variantCheckbox.on("click", checkVisibleFields);

                checkVisibleFields();
                //end Checkbox behaviour 

                //start Cross Sell behaviour 
                $addonCheckButton.on("click", detectCrossSellClick);
                //end Cross Sell behaviour 
            } else {
                //live or preview 
                const $mainContainer = $scope.find(".agnostic-product-card-pricing");
                const showDemotedPrice = $mainContainer.hasClass("display-discount-and-rrp");
                const showDiscountPrice = $mainContainer.hasClass("display-discount-text") || $mainContainer.hasClass("display-discount-number") || showDemotedPrice;
                const $basePriceSection = $scope.find(".base-price-section");
                const $baseMainPriceLine = $basePriceSection.find(".main-price-line");
                const $baseDemotedPriceSection = $baseMainPriceLine.find(".sage-product-card-demoted-price");
                const $baseActualPriceSection = $baseMainPriceLine.find(".price");
                const $basePromoSection = $basePriceSection.find(".sage-agnostic-product-card-promo");
                const $baseCtaSection = $scope.find(".base-product-ctas");

                //Addon logic 
                const $addonPriceSection = $scope.find(".addon-price-section");
                const $addonDemotedPriceSection = $addonPriceSection.find(".main-price-line .sage-product-card-demoted-price");
                const $addonActualPriceSection = $addonPriceSection.find(".main-price-line .price");
                const $addonPromoSection = $addonPriceSection.find(".sage-agnostic-product-card-promo");
                const $addonToggleSection = $scope.find(".sage-product-card-addon-alt");
                const $addonLabel = $addonToggleSection.find(".sage-product-card-addon-label-alt");
                const $addonCheck = $addonToggleSection.find(".addon-chk");
                const $addonCtaSection = $scope.find(".addon-product-ctas");
                const $addonModalBtn = $baseCtaSection.find(".sage-modal-button");

                let baseProductData = {
                    sku: productSku,
                    promoCode: null
                };
                let addonProductData = {
                    sku: addonSku,
                    promoCode: null
                };

                const processPromoTemplate = function (promoTemplate, cartText, price, savings) {
                    if (promoTemplate !== null && promoTemplate !== undefined) {
                        return promoTemplate
                            .replace("{cartText}", cartText)
                            .replace("[cartText]", cartText)
                            .replace("[promo_name]", cartText)
                            .replace("[promo name]", cartText)
                            .replace("{promo name}", cartText)
                            .replace("{promo_name}", cartText)
                            .replace("[listPrice]", price)
                            .replace("{listPrice}", price)
                            .replace("[promo_base_price]", price)
                            .replace("{promo_base_price}", price)
                            .replace("[price]", price)
                            .replace("{price}", price)
                            .replace("{yousave}", savings)
                            .replace("[yousave]", savings)
                            .replace("[promo_savings]", savings)
                            .replace("{promo_savings}", savings)
                            .replace("[total savings]", savings)
                            .replace("{total savings}", savings);
                    }
                    return promoTemplate;
                }

                const processAddonTokenReplacement = function (inputText, baseProductPrices, addonPrices) {
                    inputText.replace("[base-rrp]", baseProductPrices.formattedListPrice);
                    if (baseProductPrices.listPrice === 0) {
                        inputText = inputText.replace("[base-rrp-text]", freeLabel);
                    } else {
                        inputText = inputText.replace("[base-rrp-text]", baseProductPrices.formattedListPrice);
                    }
                    inputText = inputText.replace("[base-discount-price]", baseProductPrices.formattedDiscountedPrice);
                    if (baseProductPrices.discountedPrice === 0) {
                        inputText = inputText.replace("[base-discount-price-text]", freeLabel);
                    } else {
                        inputText = inputText.replace("[base-discount-price-text]", baseProductPrices.formattedDiscountedPrice);
                    }

                    inputText = inputText.replace("[addon-rrp]", addonPrices.formattedListPrice);
                    if (addonPrices.listPrice === 0) {
                        inputText = inputText.replace("[addon-rrp-text]", freeLabel);
                    } else {
                        inputText = inputText.replace("[addon-rrp-text]", addonPrices.formattedListPrice);
                    }
                    inputText = inputText.replace("[addon-discount-price]", addonPrices.formattedDiscountedPrice);
                    if (addonPrices.discountedPrice === 0) {
                        inputText = inputText.replace("[addon-discount-price-text]", freeLabel);
                    } else {
                        inputText = inputText.replace("[addon-discount-price-text]", addonPrices.formattedDiscountedPrice);
                    }

                    return inputText;
                }

                const processAddonModal = function (baseProductHref, addonProductHref, baseProductPrices, addonPrices) {
                    if (addonFlag && $addonModalBtn.length > 0) {
                        const addonModalId = $addonModalBtn.attr("id");
                        const $addonModal = $(`#${addonModalId}-Modal`);
                        if ($addonModal.length > 0) {
                            if (addonProductHref && isValidInternalUrl(addonProductHref)) {
                                const $primaryBtn = $addonModal.find(".button--primary");
                                $primaryBtn.attr("href", addonProductHref);
                            }
                            if (baseProductHref && isValidInternalUrl(baseProductHref)) {
                                const $tertiaryBtn = $addonModal.find(".button-tertiary");
                                $tertiaryBtn.attr("href", baseProductHref);
                            }

                            var modalText = processAddonTokenReplacement($addonModal.html(), baseProductPrices, addonPrices);
                            $addonModal.html(modalText);
                        }
                    }
                }

                if (addonFlag) {
                    $addonCheck.on("change",
                        function () {
                            const isChecked = $(this).is(":checked");
                            let dataToUse = null;

                            if (isChecked) {
                                //show addon, hide base 
                                $basePriceSection.hide();
                                $baseCtaSection.hide();
                                $addonPriceSection.show();
                                $addonCtaSection.show();
                                $addonLabel.text($(this).attr("data-remove"));

                                dataToUse = addonProductData;
                            } else {
                                //show base, hide addon 
                                $addonPriceSection.hide();
                                $addonCtaSection.hide();
                                $basePriceSection.show();
                                $baseCtaSection.show();
                                $addonLabel.text($(this).attr("data-add"));

                                dataToUse = baseProductData;
                            }

                            eventManager.trigger("refresh-agnostic-cards");

                            if (dataToUse) {
                                productService.productDetailEvent(
                                    dataToUse.sku,
                                    productSku,
                                    dataToUse.promoCode,
                                    locale,
                                    "pageview",
                                    false
                                )
                            }
                        });


                }
                //End Addon Logic
                
                //Cross Sell logic 
                let resizeTimeout;
                const $modalLaunchBtn = $scope.find(".cta-section .modal-product-btn");
                const $crossSellModal = $scope.find(".product-card-dynamic-modal");
                if ($crossSellModal.length > 0) {
                    $crossSellModal.appendTo("body");
                }
                const $modalContent = $(".modal-content", $crossSellModal);
                const $crossSellBuyWithoutBtn = $crossSellModal.find(".non-addon-button-section .modal-product-btn");
                const $addonsSection = $crossSellModal.find(".addons");
                const $modalContentHeaderTitle = $crossSellModal.find(".left-side-section .section-header-section .score-section-header h2");
                const modalTitle = $modalContentHeaderTitle.text().trim();
                const $radioButtonSection = $(".radio-buttons-section", $crossSellModal);
                const $confirmSection = $(".confirm-section", $crossSellModal);
                const $confirmSelectionButtonTemplate = $confirmSection.find(".confirm-template");
                const $defaultConfirmSelectionButton = $confirmSection.find(`.confirm-${productSku} .score-button`);
                const selectionTemplate = $radioButtonSection.find("label[for='template']");
                if (crossSellFlag) {
                    $confirmSection.on("click", ".button-checkout", function (e) {
                        // do not allow going to cart until events have fired 
                        e.preventDefault();

                        const productId = $(this).attr("data-product");
                        const promoCode = $(this).attr("data-promo"); // fix typo
                        if (productId !== "default") {
                            triggerProductCardDetailEvent(productId, productSku, promoCode);
                        }

                        var buttonText = $(this).text().trim();
                        new modalEvents("pop_up_window_click", modalTitle, buttonText).trigger();

                        const targetHref = $(this).attr("href");

                        const redirectToURL = () => { location.href = targetHref; };
                        if (targetHref.includes("sku=")) {
                            const productService = new ProductCardDetailEvent();
                            productService.triggerAddToCartTealiumEvent(targetHref, $(this), "Popup", redirectToURL);
                        } else {
                            redirectToURL();
                        }
                    });

                    $crossSellBuyWithoutBtn.on("click", function (e) {
                        e.preventDefault();

                        var buttonText = $(this).text().trim();
                        new modalEvents("pop_up_window_click", modalTitle, buttonText).trigger();

                        const targetHref = $(this).attr("href");

                        const redirectToURL = () => { location.href = targetHref; };
                        if (targetHref.includes("sku=")) {
                            const productService = new ProductCardDetailEvent();
                            productService.triggerAddToCartTealiumEvent(targetHref, $(this), "Popup", redirectToURL);
                        } else {
                            redirectToURL();
                        }
                    });

                    $crossSellModal.on("click", ".addon .button-checkout",
                        function (e) {
                            // do not allow going to cart until events have fired 
                            e.preventDefault();

                            var addonSku = $(this).parents(".addon").attr("data-addon-sku");
                            var promoCode = $(this).parents(".addon").attr("data-promocode");

                            triggerProductCardDetailEvent(addonSku,
                                productSku,
                                promoCode);
                            var buttonText = $(this).text().trim();
                            new modalEvents("pop_up_window_click", modalTitle, buttonText).trigger();

                            const targetHref = $(this).attr("href");

                            const redirectToURL = () => { location.href = targetHref; };
                            if (targetHref.includes("sku=")) {
                                const productService = new ProductCardDetailEvent();
                                productService.triggerAddToCartTealiumEvent(targetHref, $(this), "Popup", redirectToURL);
                            } else {
                                redirectToURL();
                            }
                        });

                    let firstElement;
                    let lastElement;
                    const prevFocusableElement = document.activeElement;

                    $crossSellModal.on("show.bs.modal", function (e) {
                        $crossSellModal.attr("aria-hidden", false);
                        const focusableElements = Array.from(e.target.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not(.chrome-ui-button):not(#chrome-url-bar), input[type="radio"]'));

                        if (focusableElements != null && focusableElements.length > 0) {
                            firstElement = focusableElements[0];
                            lastElement = focusableElements[focusableElements.length - 1];
                        }

                        trapFocus(true, firstElement, lastElement, prevFocusableElement);
                    });

                    $crossSellModal.on("shown.bs.modal", function (e) {
                        new modalEvents("pop_up_window_display", modalTitle).trigger();
                        resizeFunc();
                    });

                    $crossSellModal.on("hidden.bs.modal",
                        function (e) {
                            $modalLaunchBtn.focus();
                            const $styleBox = $modalLaunchBtn.parent().closest(".score-style-box");
                            if ($styleBox)
                                $styleBox.focus();

                            trapFocus(false, firstElement, lastElement, prevFocusableElement);

                            new modalEvents("pop_up_window_close", modalTitle).trigger();
                            $crossSellModal.attr("aria-hidden", true);
                        });
                }

                function trapFocus(isModalOpen, firstElement, lastElement, prevFocusableElement) {
                    const handleFocus = e => {

                        if (e.keyCode === 9) {
                            if (!e.shiftKey && $(e.target).is(lastElement)) {
                                e.preventDefault();
                                firstElement.focus();
                            } else if (e.shiftKey && $(e.target).is(firstElement)) {
                                e.preventDefault();
                                lastElement.focus();
                            }
                        }
                    };

                    if (isModalOpen) {
                        firstElement.focus();
                        document.addEventListener("keydown", handleFocus, true);
                    }
                    else {
                        document.removeEventListener("keydown", handleFocus, true);
                        prevFocusableElement.focus();
                    }
                }

                const triggerProductCardDetailEvent = function (addonSku, baseSku, addonPromoCode) {
                    //Make call to tealium 
                    productService.productDetailEvent(addonSku, baseSku, addonPromoCode, locale, "modal window", true);
                }

                const updateRadioButton = () => {
                    const selectedRadioBtn = $("input[type='radio']:checked", $crossSellModal);
                    const selectedRadioSku = selectedRadioBtn.attr("id");
                    const selectedConfirmBtn = $confirmSection.find(`div[data-confirm-sku='${selectedRadioSku}']`);
                    const unselectedConfirmBtn = $confirmSection.find(`div[data-confirm-sku!='${selectedRadioSku}']`);
                    unselectedConfirmBtn.hide();
                    selectedConfirmBtn.show();

                    const validIndex = selectedRadioBtn.attr("data-index");

                    const features = $(".features .feature", $crossSellModal);
                    features.each(function (i, el) {
                        const thisIndex = $(el).attr("data-valid-index");
                        if (thisIndex <= validIndex) {
                            $(el).addClass("included");
                        } else {
                            $(el).removeClass("included");
                        }
                    });

                    // where we set the confirm selection url on radio button changes 
                    const buyUrl = selectedRadioBtn.attr("data-buy-url");
                    if (buyUrl && isValidInternalUrl(buyUrl)) {
                        selectedConfirmBtn.attr("href", buyUrl);
                    }

                    //update promo-details section 
                    const $promoDetails = $radioButtonSection.find(".promo-details");
                    $promoDetails.text(selectedRadioBtn.attr("data-promo"));

                    //Trigger view event 
                    const radioProductSku = selectedRadioBtn.attr("product-sku");
                    const radioBundleSku = selectedRadioBtn.attr("bundle-sku");
                    const promoCode = selectedRadioBtn.attr("promo-code");
                    triggerProductCardDetailEvent(radioBundleSku,
                        productSku,
                        promoCode);
                };

                $radioButtonSection.on("change", updateRadioButton);

                //When the base product variant changes, the modal needs to change 
                //So need to store the different products 
                let baseProductJsonData;

                //Helper functions to normalise and compare, outside to avoid redefinition
                const normalize = s => (typeof s === "string" ? s.trim().toUpperCase() : "");
                const includesSku = (arr, target) => Array.isArray(arr) && target && arr.some(x => typeof x === "string" && normalize(x) === target);

                //Helper: choose the bundle that actually pairs with the base product 
                function pickBundleForBase(product, baseSkuRaw) {
                    try {
                        const bundles = Array.isArray(product.bundles) ? product.bundles : [];

                        if (!bundles.length) {
                            log("Cross-sell: no bundles available for product");
                            return null;
                        }

                        //Normalise the base sku for comparison
                        const baseSku = typeof baseSkuRaw === "string" ? baseSkuRaw.trim().toUpperCase() : "";

                        //Prefer the bundle that includes the base SKU 
                        const byBase = bundles.find(b => includesSku(b.bundledItems, baseSku));

                        if (byBase) {
                            log(`Cross-sell: picked bundle by base match → ${byBase.bundleSku}`);
                            return byBase;
                        }

                        //Next best: bundle with a populated promotion object 
                        const withPromo = bundles.find(b => typeof b.promotion === "object" && b.promotion !== null);

                        if (withPromo) {
                            log(`Cross-sell: picked bundle with promo → ${withPromo.bundleSku}`);
                            return withPromo;
                        }

                        //Fallback to first bundle 
                        if (bundles[0]) {
                            log(`Cross-sell: fallback to first bundle → ${bundles[0].bundleSku}`);
                        } else {
                            log("Cross-sell: no bundles available for product");
                        }

                        return bundles[0];
                    } catch (e) {
                        log(`Cross-sell: pickBundleForBase error → ${e.message || e}`);
                        return null;
                    }
                }

                const dealWithCrossSellModal = function (baseVariantId = 0) {
                    if (crossSellFlag) {
                        let baseTotals = baseProductJsonData.product.totals;
                        let selectedVariant;
                        if (baseProductJsonData.product.variants) {
                            for (let i = 0; i < baseProductJsonData.product.variants.length; i++) {
                                if (baseProductJsonData.product.variants[i].id == baseVariantId) {
                                    selectedVariant = baseProductJsonData.product.variants[i];
                                }
                            }

                            if (!selectedVariant) {
                                //Hasn't selected a variant, so need to select the first 
                                selectedVariant = baseProductJsonData.product.variants[0];
                            }
                        }

                        if (selectedVariant) {
                            baseTotals = selectedVariant.totals;
                        }

                        let productsList = [];

                        $(baseProductJsonData.product.crosssell).each(function (i, product) {
                            log(`Cross-sell: building modal list — product ${product.id} (${product.shortName || product.name || product.displayName})`);
                            if (product.variants !== null) {
                                $(product.variants).each(function (j, variant) {
                                    let productToAdd = JSON.parse(JSON.stringify(product));
                                    productToAdd.variants = null;
                                    productToAdd.totals = variant.totals;
                                    productToAdd.SKU = product.id;
                                    productToAdd.id = variant.id;
                                    productToAdd.name = variant.name;
                                    productToAdd.isVariant = true;

                                    productsList.push(productToAdd);
                                });
                            }
                            else {
                                product.name = product.shortName;
                                product.isVariant = false;
                                product.SKU = product.id;

                                productsList.push(product);
                            }
                        });

                        if (optionsAsRadio) {
                            let radioButtonTemplate;
                            let baseProductSku;
                            let baseProdBuyUrl;
                            baseProductSku = baseProductJsonData.product.id;
                            baseProdBuyUrl = baseProductJsonData.BuyUrl;
                            if (baseProdBuyUrl && isValidInternalUrl(baseProdBuyUrl)) {
                                if (selectedVariant) {
                                    if (baseProdBuyUrl.indexOf("?") > 0) {
                                        baseProdBuyUrl += "&vid=" + selectedVariant.id;
                                    }
                                    else {
                                        baseProdBuyUrl += "?vid=" + selectedVariant.id;
                                    }
                                }
                            }

                            if ($mainContainer.hasClass("display-discount-number")) {
                                radioButtonTemplate =
                                    '<span class="selection-price"><strong class="price-value">[discount-price]</strong>[pricePostText]</span>';
                            } else if ($mainContainer.hasClass("display-discount-text")) {
                                radioButtonTemplate =
                                    '<span class="selection-price"><strong class="price-value">[discount-price-text]</strong></span>';
                            } else if ($mainContainer.hasClass("display-discount-and-rrp")) {
                                radioButtonTemplate =
                                    '<span class="selection-price"><del class="demoted-price">[rrp]</del>&nbsp;<strong class="price-value">[discount-price]</strong>[pricePostText]</span>';
                            } else if ($mainContainer.hasClass("display-rrp-text")) {
                                radioButtonTemplate =
                                    '<span class="selection-price"><strong class="price-value">[rrp-text]</strong>[pricePostText]</span>';
                            } else {
                                radioButtonTemplate =
                                    '<span class="selection-price"><strong class="price-value">[rrp]</strong>[pricePostText]</span>';
                            }

                            radioButtonTemplate = radioButtonTemplate.replace("[pricePostText]", crossSellPricePostText);

                            if ($defaultConfirmSelectionButton.length > 0) {
                                $defaultConfirmSelectionButton.attr("data-buy-url", baseProdBuyUrl);
                                if (baseProdBuyUrl && isValidInternalUrl(baseProdBuyUrl)) {
                                    $defaultConfirmSelectionButton.attr("href", baseProdBuyUrl);
                                }
                            }

                            //add baseurl to radio input 
                            const noThanksRadioButton = $("input[type='radio'][name='" + modalId + "-product_selection']");
                            noThanksRadioButton.attr("data-buy-url", baseProdBuyUrl);
                            $(noThanksRadioButton).prop("checked", true);

                            //Remove any existing stuff, apart from the default and templates 
                            $confirmSection.find(`div:not(.confirm-${baseProductSku})`).remove();
                            $radioButtonSection.find(`label:not([for='${modalId}-${productSku}'])`).remove();

                            $(productsList).each(function (i, product) {
                                const labelObj = $(selectionTemplate).clone();
                                const inputObj = $(labelObj).find("input");
                                const selectionName = $(labelObj).find("span.selection-name");
                                const selectionLabel = $(labelObj).find("p.selection-label");

                                $(labelObj).show();
                                $(labelObj).attr("for", `${modalId}-${product.SKU}${product.isVariant ? "-" + product.id : ""}`);
                                $(inputObj).attr("id", `${modalId}-${product.SKU}${product.isVariant ? "-" + product.id : ""}`);
                                $(inputObj).attr("data-index", i);
                                $(inputObj).attr("product-sku", product.SKU);
                                const activeBundle = pickBundleForBase(product, baseProductJsonData.product.id);

                                if (!activeBundle) {
                                    log(`No active bundle found for product SKU: ${product.SKU}, baseProductId: ${baseProductJsonData.product.id}`);
                                    return; // skip this product
                                }

                                $(inputObj).attr("bundle-sku", activeBundle.bundleSku);

                                if (product.isVariant) {
                                    $(inputObj).attr("variant-id", product.id);
                                }

                                $(inputObj).prop("checked", false);

                                let selectionPriceHtml = radioButtonTemplate;
                                selectionPriceHtml = selectionPriceHtml.replace("[rrp]", `${product.totals.formattedListPrice} `);

                                //set promo pill text 
                                var promoPillText;

                                let promoCode = undefined;
                                if (activeBundle && typeof activeBundle.promotion === "object" && activeBundle.promotion !== null) {
                                    const promo = activeBundle.promotion;
                                    const value = promo.Value;
                                    if (promo.DiscountedPrice === 0) {
                                        promoPillText = crossSellRadioPromoPillFreeText.replace("[promoLength]", promo.promoLength);
                                    } else {
                                        promoPillText = crossSellRadioPromoPillDiscountText.replace("[promoValue]", value);
                                        promoPillText = promoPillText.replace("[promoLength]", promo.promoLength);
                                    }
                                    promoPillText = replacePromoPeriod(promoPillText, promo.promoLengthType, promo.promoLength);
                                    promoCode = promo.name;
                                    const $promoDetails = $radioButtonSection.find(".promo-details");
                                    $promoDetails.text(promoPillText);

                                    $(inputObj).attr("promo-code", promoCode);
                                    log(`Cross-sell (radio): promo applied → bundle=${activeBundle.bundleSku}, code=${promoCode}, pill="${promoPillText}"`);
                                } else if (productsList.length === (i + 1)) {                                    
                                    //no products have promos so remove promo pill 
                                    const $promoDetails = $radioButtonSection.find(".promo-details");
                                    $promoDetails.remove();
                                    log("Cross-sell (radio): no promos found across products — removed promo pill");
                                }

                                $(inputObj).attr("data-promo", promoPillText);

                                if (activeBundle && typeof activeBundle.promotion === "object" && activeBundle.promotion !== null) {
                                    //Pricing logic 
                                    if (showDiscountPrice) {
                                        if ($mainContainer.hasClass("display-discount-text") &&
                                            activeBundle.promotion.DiscountPrice === 0) {
                                            selectionPriceHtml = selectionPriceHtml.replace("[discount-price]", `${product.totals.formattedDiscountedPrice} ${crossSellRadioExtraText} `);
                                            selectionPriceHtml = selectionPriceHtml.replace("[discount-price-text]", freeLabel);
                                        } else {
                                            selectionPriceHtml = selectionPriceHtml.replace("[discount-price]", `${product.totals.formattedDiscountedPrice} ${crossSellRadioExtraText} `);
                                            selectionPriceHtml = selectionPriceHtml.replace("[discount-price-text]", `${product.totals.formattedDiscountedPrice} ${crossSellRadioExtraText} `);
                                        }
                                    } else {
                                        // must be default of display rrp chosen 
                                        if ($mainContainer.hasClass("display-rrp-text") && product.Price === 0) {
                                            selectionPriceHtml = selectionPriceHtml.replace("[rrp-text]", freeLabel);
                                        } else {
                                            selectionPriceHtml = selectionPriceHtml.replace("[rrp-text]", `${product.totals.formattedListPrice} ${crossSellRadioExtraText}`);
                                        }
                                    }
                                } else {
                                    //no promo 
                                    if ($mainContainer.hasClass("display-rrp-text") && product.Price === 0) {
                                        selectionPriceHtml = selectionPriceHtml.replace("[rrp-text]", freeLabel);
                                    } else {
                                        selectionPriceHtml = selectionPriceHtml.replace("[rrp-text]", `${product.totals.formattedListPrice} ${crossSellRadioExtraText}`);
                                    }
                                }
                                //create confirm selection button for crossell variant 
                                let $customConfirmButton = $confirmSelectionButtonTemplate.clone();
                                $customConfirmButton.removeClass("confirm-template");
                                $customConfirmButton.addClass(`confirm-${product.id}`);
                                $customConfirmButton.attr("data-confirm-sku", `${modalId}-${product.SKU}${product.isVariant ? "-" + product.id : ""}`);
                                $customConfirmButton.find(".button-checkout")
                                    .attr("data-product", product.SKU)
                                    .attr("data-variant", product.id)
                                    .attr("data-promo", promoCode);
                                let productBuyUrl = product.BundleBuyUrl;
                                if (productBuyUrl && isValidInternalUrl(productBuyUrl)) {
                                    if (selectedVariant || product.isVariant) {
                                        let variantId = selectedVariant ? selectedVariant.id : product.id;

                                        if (productBuyUrl.indexOf("?") > 0) {
                                            productBuyUrl += "&vid=" + variantId;
                                        }
                                        else {
                                            productBuyUrl += "?vid=" + variantId;
                                        }
                                    }
                                }
                                $customConfirmButton.attr("data-buy-url", productBuyUrl);
                                $customConfirmButton.find('.button-checkout').attr("href", productBuyUrl);
                                $confirmSection.append($customConfirmButton);

                                selectionName.text(product.isVariant ? product.name : `Yes, add ${product.name}`);
                                selectionLabel.append(selectionPriceHtml);

                                $radioButtonSection.append(labelObj);
                            });
                            $(selectionTemplate).remove();
                            $confirmSelectionButtonTemplate.remove();

                            //Select the first radio button 
                            updateRadioButton();
                            eventManager.trigger("adjust-agnostic-cards");
                        }
                        else {
                            let buyUrl;
                            if (baseProductJsonData.BuyUrl && isValidInternalUrl(baseProductJsonData.BuyUrl)) {
                                buyUrl = baseProductJsonData.BuyUrl;
                                if (selectedVariant) {
                                    if (buyUrl.indexOf("?") > 0) {
                                        buyUrl += "&vid=" + selectedVariant.id;
                                    }
                                    else {
                                        buyUrl += "?vid=" + selectedVariant.id;
                                    }
                                }
                            }

                            $crossSellBuyWithoutBtn.attr("href", buyUrl);
                            const $dropdownLabel = $crossSellModal.find(".dropdown-label");
                            let familyName = productsList[0].productFamily;

                            $dropdownLabel.text($dropdownLabel.text().replace("[productName]", familyName));

                            $addonsSection.find(".addon[data-addon-sku!='Template']").remove();

                            let selectBoxTemplate = selectBoxFormat;
                            if (selectBoxTemplate.trim() === "") {
                                if ($mainContainer.hasClass("display-discount-number")) {
                                    selectBoxTemplate =
                                        '<span class="product-name">[product-name]</span>&nbsp; <span class="price">[discount-price][pricePostText]</span>';
                                } else if ($mainContainer.hasClass("display-discount-text")) {
                                    selectBoxTemplate =
                                        '<span class="product-name">[product-name]</span>&nbsp; <span class="price">[discount-price-text]</span>';
                                } else if ($mainContainer.hasClass("display-discount-and-rrp")) {
                                    selectBoxTemplate =
                                        '<span class="product-name">[product-name]</span>&nbsp; <del class="demoted-price">[rrp]</del>&nbsp; <span class="price">[discount-price][pricePostText]</span>';
                                } else if ($mainContainer.hasClass("display-rrp-text")) {
                                    selectBoxTemplate =
                                        '<span class="product-name">[product-name]</span>&nbsp; <span class="price">[rrp-text][pricePostText]</span>';
                                } else {
                                    selectBoxTemplate =
                                        '<span class="product-name">[product-name]</span>&nbsp; <span class="price">[rrp][pricePostText]</span>';
                                }
                            }

                            selectBoxTemplate = selectBoxTemplate.replace("[pricePostText]", crossSellPricePostText);

                            const addonTemplate = $addonsSection.find(".addon[data-addon-sku='Template']").get(0);

                            let firstProductOption = undefined;
                            let dropDownData = [];

                            $(productsList).each(function (i, product) {
                                //Select box logic 
                                let productsName;
                                let formattedRRPPrice;
                                let formattedPrice;
                                let sku;
                                let bundleSku;
                                let promo;
                                let bundleRRPPrice;
                                let formattedBundleRRPPrice;
                                productsName = product.shortName;
                                formattedPrice = product.totals.formattedDiscountedPrice;
                                formattedRRPPrice = product.totals.formattedListPrice;
                                sku = product.id;
                                const activeBundle = pickBundleForBase(product, baseProductJsonData.product.id);
                                bundleSku = activeBundle ? activeBundle.bundleSku : null;
                                promo = activeBundle ? activeBundle.promotion : null;
                                bundleRRPPrice = product.totals.PriceWithBasePrice;
                                formattedBundleRRPPrice = product.totals.FormattedPriceWithBasePrice;
                                const $detailsObj = $(addonTemplate).clone();
                                $detailsObj.attr("data-addon-sku", sku);
                                $detailsObj.attr("data-bundle-sku", bundleSku);
                                let innerLinkHtml = selectBoxTemplate;
                                innerLinkHtml = innerLinkHtml.replace("[product-name]", product.name);
                                innerLinkHtml = innerLinkHtml.replace("[rrp]", formattedRRPPrice);
                                if (i === 0) {
                                    firstProductOption = sku;
                                }
                                if (product.PriceDemoted || $mainContainer.hasClass("display-discount-and-rrp")) {
                                    //This needs to be the price of the base variant and the price of this product, formatted correctly
                                    //Also changes if including tax, or forcing to 2 significant digits
                                    const combinedPrice = formatPrice(bundleRRPPrice);
                                    $detailsObj.find(".demoted-price")
                                        .text(combinedPrice);
                                }
                                let promoCode = undefined;
                                let totalPrice = undefined;
                                if (promo && typeof promo === "object") {
                                    let code;
                                    let listPrice;
                                    let DiscountedPrice;
                                    let FormattedDiscountPrice;
                                    let FormattedBundlePrice;
                                    let FormattedPrice;
                                    code = promo.name;
                                    listPrice = product.totals.listPrice;
                                    //no formatedbundle price yet 
                                    FormattedBundlePrice = product.FormattedBundlePrice;
                                    FormattedPrice = product.totals.formattedListPrice;
                                    DiscountedPrice = product.totals.discountedPrice;
                                    FormattedDiscountPrice = product.totals.formattedDiscountedPrice;

                                    const totalRRP = bundleRRPPrice;
                                    const totalSavings = product.totals.totalDiscountOverPeriod;


                                    const promotionBanner =
                                        $detailsObj.find(".sage-dynamic-modal-product-card-promotion-banner");
                                    promotionBanner.empty(); // Clear any existing content to prevent conflicts 
                                    //Need to use the template to insert the appropriate figures based upon the base variant 
                                    const promoHtml = processPromoTemplate(promo.promoHtmlTemplate, promo.displayText, formatPrice(totalRRP), formatPrice(totalSavings));
                                    log(`Cross-sell (dropdown): promo applied → bundle=${bundleSku}, code=${code}, price=${formatPrice(totalRRP)}, save=${formatPrice(totalSavings)}`);
                                    promotionBanner.append(sanitizer.sanitizeHtml(promoHtml)); // Append the HTML content 
                                    $detailsObj.find(".sage-dynamic-modal-product-card-promo").show();
                                    promoCode = code;
                                    $detailsObj.attr("data-promocode", promoCode);
                                    //Pricing logic 

                                    totalPrice = product.totals.DiscountedPriceWithBasePrice;

                                        if ($mainContainer.hasClass("display-discount-text") &&
                                            DiscountedPrice === 0) {
                                            if (totalPrice === 0) {
                                                totalPrice = freeLabel;
                                            }
                                            innerLinkHtml = innerLinkHtml.replace("[discount-price]",
                                                FormattedDiscountPrice);
                                            innerLinkHtml = innerLinkHtml.replace("[discount-price-text]", freeLabel);
                                        } else {
                                            innerLinkHtml = innerLinkHtml.replace("[discount-price]",
                                                FormattedDiscountPrice);
                                            innerLinkHtml = innerLinkHtml.replace("[discount-price-text]",
                                                FormattedDiscountPrice);
                                        }
                                        
                                    // must be default of display rrp chosen
                                    if ($mainContainer.hasClass("display-rrp-text")) {
                                        totalPrice = bundleRRPPrice;

                                        if (listPrice === 0) {
                                                if (totalPrice === 0) {
                                                    totalPrice = freeLabel;
                                                }
                                                innerLinkHtml = innerLinkHtml.replace("[rrp-text]", freeLabel);
                                            }
                                            else {
                                                innerLinkHtml = innerLinkHtml.replace("[rrp-text]", FormattedPrice);
                                            }
                                        } else {
                                            innerLinkHtml = innerLinkHtml.replace("[rrp-text]", FormattedPrice);
                                        }
                                    }
                                else {
                                    log(`Cross-sell (dropdown): no promo object for bundle=${bundleSku} — rendering without promo`);

                                    let listPrice;
                                    let FormattedBundlePrice;
                                    let FormattedPrice;
                                    listPrice = product.totals.listPrice;
                                    //no formatedbundle price yet 
                                    FormattedBundlePrice = product.BundlePrice;

                                    totalPrice = bundleRRPPrice;
                                    //no promo
                                    if ($mainContainer.hasClass("display-rrp-text") && listPrice === 0) {
                                        if (totalPrice === 0) {
                                            totalPrice = freeLabel;
                                        }
                                        innerLinkHtml = innerLinkHtml.replace("[rrp-text]", freeLabel);
                                    } else {
                                        innerLinkHtml = innerLinkHtml.replace("[rrp-text]", FormattedPrice);
                                    }
                                }
                                if (product.isVariant) {
                                    dropDownData.push({ optionHtml: innerLinkHtml, "identifier": sku, "variant": "vid" + product.id });
                                    $detailsObj.attr("data-variant", "vid" + product.id);
                                }
                                else {
                                    dropDownData.push({ optionHtml: innerLinkHtml, identifier: sku, variant: undefined });
                                }
                                $detailsObj.find(".price").text(formatPrice(totalPrice));
                                let productBuyUrl = product.BundleBuyUrl;
                                if (productBuyUrl && isValidInternalUrl(productBuyUrl)) {
                                    if (selectedVariant || product.isVariant) {
                                        let variantId = selectedVariant ? selectedVariant.id : product.id;
                                        if (productBuyUrl.indexOf("?") > 0) {
                                            productBuyUrl += "&vid=" + variantId;
                                        }
                                        else {
                                            productBuyUrl += "?vid=" + variantId;
                                        }
                                    }
                                    $detailsObj.find(".button-checkout").attr("href", productBuyUrl);
                                    log(`Cross-sell (dropdown): set BuyUrl for bundle=${bundleSku} → ${productBuyUrl}`);
                                }
                                $addonsSection.append($detailsObj);
                                eventManager.trigger("adjust-agnostic-cards");
                            });
                            if (dropDownData.length > 0) {
                                eventManager.trigger(`select-drop-down-replace-options-${modalId}`, { options: dropDownData });
                                log(`Cross-sell (dropdown): replaced select options with ${dropDownData.length} entries`);
                            }
                        }
                    }
                }
                function resizeFunc() {
                    window.clearTimeout(resizeTimeout);
                    if (crossSellFlag && $crossSellModal.length > 0) {
                        const maxHeight = $crossSellModal.innerHeight();
                        const windowWidth = $(window).width();
                        const $leftSide = $modalContent.find(".left-side-section");
                        const $rightSide = $modalContent.find(".right-side-section");
                        $leftSide.height("auto");
                        $rightSide.height("auto");
                        $modalContent.height("auto");
                        //Catch to ensure the calculations will be valid 
                        if ($leftSide.outerHeight() > 0 && $rightSide.outerHeight() > 0) {
                            let targetHeight = $leftSide.outerHeight();
                            if (windowWidth < 1080) {
                                targetHeight += $rightSide.outerHeight();
                            } else if ($rightSide.outerHeight() > targetHeight) {
                                targetHeight = $rightSide.outerHeight();
                            }
                            if (maxHeight < targetHeight) {
                                targetHeight = maxHeight;
                            }
                            if (windowWidth >= 1080) {
                                $leftSide.outerHeight(`${targetHeight}px`);
                                $rightSide.outerHeight(`${targetHeight}px`);
                            }
                            $modalContent.height(`${targetHeight}px`);
                        }
                    }
                };
                if (crossSellFlag) {
                    if (!optionsAsRadio) {
                        eventManager.subscribe(`select-drop-down-option-selected-${modalId}`,
                            function (obj) {
                                if (crossSellFlag) {
                                    const selectedSku = obj.identifier;
                                    const validIndex = obj.index;
                                    const variant = obj.variant;
                                    const selectedAddon = variant !== undefined ?
                                        $addonsSection.find(`.addon[data-addon-sku='${selectedSku}'][data-variant='${variant}']`)
                                        : $addonsSection.find(`.addon[data-addon-sku='${selectedSku}']`);
                                    const unselectedAddon = variant !== undefined ?
                                        $addonsSection.find(`.addon[data-addon-sku='${selectedSku}'][data-variant!='${variant}'], .addon[data-addon-sku!='${selectedSku}']`)
                                        : $addonsSection.find(`.addon[data-addon-sku!='${selectedSku}']`);
                                    unselectedAddon.hide();
                                    selectedAddon.show();
                                    const features = $(".features .feature", $crossSellModal);
                                    features.each(function (i, el) {
                                        const thisIndex = $(el).attr("data-valid-index");
                                        if (thisIndex <= validIndex) {
                                            $(el).addClass("included");
                                        } else {
                                            $(el).removeClass("included");
                                        }
                                    });
                                    const bundleSku = selectedAddon.attr("data-bundle-sku");
                                    const promoCode = selectedAddon.attr("data-promocode");
                                    if (obj.freshList === true) {
                                        //Page load - don't want to raise event until modal appears 
                                        //But also want the event to be raised each time when the modal appears 
                                        $crossSellModal.on("shown.bs.modal", function (e) {
                                            triggerProductCardDetailEvent(bundleSku,
                                                productSku,
                                                promoCode);
                                        });
                                    }
                                    else {
                                        //Trigger view event 
                                        triggerProductCardDetailEvent(bundleSku,
                                            productSku,
                                            promoCode);
                                    }
                                    resizeFunc();
                                }
                            });
                        // run update selection on load so that features are updated 
                        $(".select-drop-down-toggle").trigger("change");
                    }
                    $(window).on("resize",
                        function () {
                            clearTimeout(resizeTimeout);
                            resizeTimeout = window.setTimeout(resizeFunc, 50);
                        });
                }
                //End Cross Sell logic 
                //Variant logic 
                const $variantSelectorSection = $scope.find(".selector-section");
                const $variantSelector = $variantSelectorSection.find("select.dynamic-select");
                let variants = [];
                const priceWithTax = false;
                let promotion = undefined;
                const contactUsFunctionality = function () {
                    if (variantFlag) {
                        const productCardButtons = $baseCtaSection.find(".score-button");
                        var contactUsText = "";
                        productCardButtons.each(function () {
                            var currentButton = $(this);
                            currentButton.hasClass("contact-us") ? currentButton.show() : currentButton.hide();
                            contactUsText = currentButton.hasClass("contact-us") ? currentButton.text() : "Contact Us";
                        });
                        $basePromoSection.hide();
                        $baseMainPriceLine.hide();
                    }
                }
                if (variantFlag === true) {
                    $($variantSelector).on("change",
                        function () {
                            var selectedValue = $(this).val();
                            if (selectedValue === "ContactUs") {
                                contactUsFunctionality();
                            } else {
                                $(".contact-us", $baseCtaSection).hide();
                                if (selectedValue !== null && selectedValue !== undefined) {
                                    var selectedVariant;
                                    var variantId = selectedValue.replace("vid", "");
                                    variants.forEach((variant) => {
                                        if (variant.id === variantId) {
                                            selectedVariant = variant;
                                        }
                                    });
                                    if (selectedVariant != null) {
                                        var variantPrice = priceWithTax
                                            ? selectedVariant.totals.formattedPriceIncModulesWithTax
                                            : selectedVariant.totals.formattedPriceIncModules;
                                        var variantPromoPrice = priceWithTax
                                            ? selectedVariant.totals.formattedDiscountedPriceWithTax
                                            : selectedVariant.totals.formattedDiscountedPrice;
                                        var variantSavingPrice = priceWithTax
                                            ? selectedVariant.totals.formattedTotalDiscountOverPeriodWithTax
                                            : selectedVariant.totals.formattedTotalDiscountOverPeriod;
                                        var hasPromo = promotion !== null &&
                                            promotion !== undefined &&
                                            promotion.promoTemplate !== null &&
                                            promotion.promoTemplate !== undefined &&
                                            promotion.promoTemplate !== "";
                                        // sort out pricing display 
                                        if (!hasPromo || !showDiscountPrice) {
                                            // only show rrp price as either there is no discount, or price box has a display rrp style 
                                            var unformattedPrice = priceWithTax ? selectedVariant.totals.priceIncModulesWithTax : selectedVariant.totals.priceIncModules;
                                            if ($mainContainer.hasClass("display-rrp-text") && Math.abs(unformattedPrice === 0)) {
                                                $baseActualPriceSection.html(freeLabel);
                                            } else {
                                                $baseActualPriceSection.html(variantPrice);
                                            }
                                            $baseDemotedPriceSection.hide();
                                        }
                                        else {
                                            // look at discount display options 
                                            var unformattedPromoPrice = priceWithTax ? selectedVariant.totals.discountedPriceWithTax : selectedVariant.totals.discountedPrice;
                                            if ($mainContainer.hasClass("display-discount-text") && Math.abs(unformattedPromoPrice === 0)) {
                                                $baseActualPriceSection.html(freeLabel);
                                            }
                                            else {
                                                $baseActualPriceSection.html(variantPromoPrice);
                                            }
                                            if ($mainContainer.hasClass("display-discount-and-rrp")) {
                                                $baseDemotedPriceSection.html(variantPrice);
                                                $baseDemotedPriceSection.show();
                                            } else {
                                                $baseDemotedPriceSection.hide();
                                            }
                                        }
                                        $baseMainPriceLine.show();
                                        // sort out promo display 
                                        if (hasPromo) {
                                            var newPromoHtml = processPromoTemplate(promotion.promoTemplate, promotion.cartText, variantPrice, variantSavingPrice);
                                            newPromoHtml = sanitizer.sanitizeHtml(newPromoHtml);
                                            $basePromoSection.html(newPromoHtml);
                                            $basePromoSection.show();
                                        }
                                        else {
                                            $basePromoSection.hide();
                                        }
                                        //Need to update the cross sell modal as well to reflect the new pricing and and vid to the buttons 
                                        if (crossSellFlag) {
                                            dealWithCrossSellModal(variantId);
                                        }
                                    }
                                    $baseCtaSection.find(".score-button").each(function () {
                                        var currentButton = $(this);
                                        if (currentButton.hasClass("contact-us")) {
                                            currentButton.hide();
                                        } else {
                                            // update button URLS with the vid selected 
                                            var currentButtonHref = currentButton.attr("href");
                                            var currentButtonDataHref = currentButton.attr("data-href");
                                            if (typeof (currentButtonDataHref) !== "undefined" && currentButtonDataHref !== null) {
                                                var url = undefined;
                                                if (currentButtonDataHref.startsWith("https://")) {
                                                    url = new URL(currentButtonDataHref);
                                                }
                                                else {
                                                    url = new URL(currentButtonDataHref, document.location.origin);
                                                }
                                                if (!currentButton.hasClass("try-button")) {
                                                    if (promotion !== null && promotion !== undefined) {
                                                        url.searchParams.set("promocode", promotion.code);
                                                    } else {
                                                        url.searchParams.delete("promocode");
                                                    }
                                                }
                                                url.searchParams.set("vid", variantId);
                                                if (url.href && isValidInternalUrl(url.href)) {
                                                    currentButton.attr("data-href", url.href);
                                                    currentButton.show();
                                                }
                                            } else {
                                                var url = undefined;
                                                if (currentButtonHref.startsWith("https://")) {
                                                    url = new URL(currentButtonHref);
                                                }
                                                else {
                                                    url = new URL(currentButtonHref, document.location.origin);
                                                }
                                                if (!$(this).hasClass("try-button")) {
                                                    if (promotion !== null && promotion !== undefined) {
                                                        url.searchParams.set("promocode", promotion.code);
                                                    } else {
                                                        url.searchParams.delete("promocode");
                                                    }
                                                }
                                                url.searchParams.set("vid", variantId);
                                                if (url.href && isValidInternalUrl(url.href)) {
                                                    currentButton.attr("href", url.href);
                                                    currentButton.show();
                                                }
                                            }
                                        }
                                    });
                                }
                                productCardAlignment.sageProductCardMatchHeight();
                            }
                        }
                    );
                }
                //End Variant Logic 
                $.ajax({
                    type: "GET",
                    url: `/sitecore/api/product/GetAgnosticPriceData/${productSku}/${locale}`,
                    data: {
                        basePromoOverwrite: promoCodeOverwrite,
                        basePromoTemplate: sanitizer.sanitizeHtml(promoTemplateOverride),
                        isCrossSell: crossSellFlag,
                        crossSellPromoOverwrite: crossSellPromoOverwrite,
                        crossSellPromoTemplate: sanitizer.sanitizeHtml(crossSellPromoTemplateOverride),
                        isAddon: addonFlag,
                        addonSku: addonSku,
                        addonPromoOverwrite: addonPromoOverwrite,
                        addonPromoTemplate: sanitizer.sanitizeHtml(addonPromoTemplate),
                        useVariants: variantFlag
                    },
                    context: this,
                    success: function (response) {
                        if (response != null) {
                            const productService = new ProductCardDetailEvent();
                            const jsonObj = JSON.parse(response);
                            let baseProduct;
                            let basePromo;
                            let basePromoCode;
                            let formattedListPrice;
                            let formattedDiscountedPrice;
                            let discountedPrice;
                            let baseBuyUrl;
                            if (crossSellFlag) {
                                baseProductJsonData = jsonObj;
                            }
                            if (addonFlag) {
                                baseProduct = jsonObj.baseProduct.product;
                                basePromo = jsonObj.baseProduct.promotion;
                                baseBuyUrl = jsonObj.baseProduct.BuyUrl;
                            } else {
                                baseProduct = jsonObj.product;
                                basePromo = jsonObj.promotion;
                                baseBuyUrl = jsonObj.BuyUrl;
                            }
                            formattedListPrice = baseProduct.totals.formattedListPrice;
                            discountedPrice = baseProduct.totals.discountedPrice;
                            formattedDiscountedPrice = baseProduct.totals.formattedDiscountedPrice;
                            if (baseBuyUrl && isValidInternalUrl(baseBuyUrl)) {
                                $baseCtaSection.find(".score-button:not(.contact-us):not(.modal-launch-btn)").first().attr("href", baseBuyUrl);
                            }
                            if (baseProduct.PriceDemoted || showDemotedPrice) {
                                $baseDemotedPriceSection.text(formattedListPrice);
                                if ($mainContainer.hasClass("display-discount-text") && discountedPrice === 0) {
                                    $baseActualPriceSection.text(freeLabel);
                                }
                                else {
                                    $baseActualPriceSection.text(formattedDiscountedPrice);
                                }
                            }
                            else {
                                if ($mainContainer.hasClass("display-discount-number") || $mainContainer.hasClass("display-discount-text")) {
                                    if ($mainContainer.hasClass("display-discount-text") && discountedPrice === 0) {
                                        $baseActualPriceSection.text(freeLabel);
                                    }
                                    else {
                                        $baseActualPriceSection.text(formattedDiscountedPrice);
                                    }
                                }
                                else {
                                    $baseActualPriceSection.text(formattedListPrice);
                                }
                            }
                            $basePriceSection.show();
                            if (basePromo !== null && basePromo !== undefined) {
                                if (!variantFlag) {
                                    //Already configured 
                                    $basePromoSection.html(basePromo.PromoHtml);
                                }
                                else {
                                    const promoText = processPromoTemplate(basePromo.promoTemplate,
                                        basePromo.cartText,
                                        formattedListPrice,
                                        baseProduct.totals.formattedTotalDiscountOverPeriod);
                                    $basePromoSection.html(promoText);
                                }
                                $basePromoSection.show();
                                basePromoCode = basePromo.code;
                                baseProductData.promoCode = basePromoCode;
                            } else {
                                $basePromoSection.hide();
                            }
                            if (crossSellFlag) {
                                // if has cross sell products, remove href from the button and attach events for launching the modal 
                                const crossSellProducts = baseProduct.crosssell;
                                if (baseBuyUrl && isValidInternalUrl(baseBuyUrl)) {
                                    $modalLaunchBtn.attr("href", baseBuyUrl);
                                    $modalLaunchBtn.attr("data-href", baseBuyUrl);
                                }
                                if (crossSellProducts.length > 0) {
                                    $modalLaunchBtn.attr("href", "#");
                                    $modalLaunchBtn.attr("role", "button");
                                    //event for the button to launch the modal 
                                    $modalLaunchBtn.on("click",
                                        function (e) {
                                            e.preventDefault();
                                            $crossSellModal.modal("show");
                                        });
                                    if (!(variantFlag && baseProduct.variants !== null && baseProduct.variants !== undefined)) {
                                        //behaviour for selecting the different products 
                                        //will be called in the variant code 
                                        dealWithCrossSellModal(0);
                                    }
                                }
                            }
                            if (variantFlag) {
                                //fill in the select box 
                                if (baseProduct.variants !== null && baseProduct.variants !== undefined) {
                                    variants = baseProduct.variants;
                                }
                                let selectorOptions = [];
                                variants.forEach((variant) => {
                                    selectorOptions.push({ "name": variant.displayName, "value": "vid" + variant.id });
                                });
                                if (useContactUs && variants.length > 0) {
                                    var lastVariant = variants[selectorOptions.length - 1];
                                    var lastVariantEmployees = lastVariant.maxEmployees;
                                    selectorOptions.push({
                                        "name": lastVariantEmployees + "+ " + employeeLabel,
                                        "value": "ContactUs"
                                    });
                                    // only show the contact us button as the buy and try buttons will not have correct url due to no variants 
                                }
                                $($variantSelector).empty();
                                for (i = 0; i < selectorOptions.length; i++) {
                                    $($variantSelector).append(new Option(selectorOptions[i].name, selectorOptions[i].value));
                                }
                                promotion = basePromo;
                                // trigger on change 
                                $($variantSelector).trigger("change");
                                if (variants.length > 0) {
                                    $variantSelectorSection.show();
                                }
                            } else if (addonFlag) {
                                const addonProduct = jsonObj.addonProduct.product;
                                const addonPromo = jsonObj.addonProduct.promotion;
                                //populate addon pricing section so that when toggle is active, just need to show the section 
                                if ((addonPromo === null || addonPromo === undefined) || !showDiscountPrice) {
                                    if ($mainContainer.hasClass("display-rrp-text") && Math.abs(addonProduct.totals.listPrice) === 0) {
                                        $addonActualPriceSection.html(freeLabel);
                                    } else {
                                        $addonActualPriceSection.html(addonProduct.totals.formattedListPrice);
                                    }
                                }
                                else {
                                    // promo is active and want to show discount price 
                                    if ($mainContainer.hasClass("display-discount-text") && Math.abs(addonProduct.totals.discountedPrice) === 0) {
                                        $addonActualPriceSection.html(freeLabel);
                                    }
                                    else {
                                        $addonActualPriceSection.html(addonProduct.totals.formattedDiscountedPrice);
                                    }
                                    if (showDemotedPrice || addonProduct.PriceDemoted) {
                                        $addonDemotedPriceSection.html(addonProduct.totals.formattedListPrice);
                                    }
                                }
                                if (addonPromo !== null && addonPromo !== undefined) {
                                    $addonPromoSection.html(addonPromo.PromoHtml);
                                    addonProductData.promoCode = addonPromo.code;
                                } else {
                                    $addonPromoSection.hide();
                                }
                                // endpoint now returns variants for some addon products (like EN-IE), so we need to add the "default" vid param to the BuyURL 
                                if (addonProduct.variants !== null) {
                                    jsonObj.addonProduct.BuyUrl += "&vid=1";
                                }
                                processAddonModal(jsonObj.baseProduct.BuyUrl, jsonObj.addonProduct.BuyUrl, baseProduct.totals, addonProduct.totals);
                                //Need to do this process on buttons, and the different toggle labels 
                                const addText = processAddonTokenReplacement($addonCheck.attr("data-add"), baseProduct.totals, addonProduct.totals);
                                $addonCheck.attr("data-add", addText);
                                $addonLabel.text(addText);
                                const removeText = processAddonTokenReplacement($addonCheck.attr("data-remove"), baseProduct.totals, addonProduct.totals);
                                $addonCheck.attr("data-remove", removeText);
                                if (jsonObj.addonProduct.BuyUrl && isValidInternalUrl(jsonObj.addonProduct.BuyUrl)) {
                                    $addonCtaSection.find(".score-button").first().attr("href", jsonObj.addonProduct.BuyUrl);
                                }
                                $addonToggleSection.show();
                            }
                            productService.productDetailEvent(
                                productSku,
                                productSku,
                                basePromoCode,
                                locale,
                                "pageview",
                                false
                            )
                            $baseCtaSection.show();
                            eventManager.trigger("refresh-agnostic-cards");
                        }
                    },
                    error: function (xhr) {
                        $(scope).hide(); // hide the component on error 
                        contactUsFunctionality();
                    }
                });
            }
        }
        AgnosticProductCardPricing.init = (args) => {
            return args.IsEditorEditing === true
                ? null
                : new AgnosticProductCardPricing(
                    args.scope,
                    args.productSku,
                    args.promoCodeOverwrite,
                    args.promoTemplate,
                    args.crossSellFlag,
                    args.crossSellPromoOverwrite,
                    args.optionsAsRadio,
                    args.crossSellPricePostText,
                    args.crossSellRadioExtraText,
                    args.crossSellRadioPromoPillFreeText,
                    args.crossSellRadioPromoPillDiscountText,
                    args.crossSellPromoTemplate,
                    args.addonFlag,
                    args.addonSku,
                    args.addonPromoOverwrite,
                    args.addonPromoTemplate,
                    args.variantFlag,
                    args.useContactUs,
                    args.selectBoxFormat,
                    args.modalId,
                    args.freeLabel,
                    args.currencyFormat,
                    args.currencyFormatWithChange,
                    args.employeeLabel,
                    args.dayLabel,
                    args.daysLabel,
                    args.monthLabel,
                    args.monthsLabel,
                    args.isEditing,
                    args.isPreview);
        };
        return AgnosticProductCardPricing;
    });

